import { List, TextField, SimpleList, Datagrid, TextInput, EditButton, TopToolbar, CreateButton } from "react-admin";
import { EmptyList } from "server/components";
import { useMediaQuery } from "@mui/material";
import { MobileListRow } from "features/MobileListRow";
import { checkPermission } from "server/security/utils";
import { getPermissions } from "auth/security/securityUtils";
import permissions from "app/permissions";
import { settings } from "app";
import { MOBILE_BREAKPOINT, ROLES } from "utils/constants";
import { SecurityExporter } from "../XlsxExporter";
import { ExportXlsButton } from "features/ExportXlsxButton";

const ListRoles = () => {
  const isMobile = useMediaQuery(MOBILE_BREAKPOINT);
  const userPermissions = getPermissions();

  const filters = [
    <TextInput
      source="name"
      label="Име"
      alwaysOn
    />,
    <TextInput
      source="description"
      label="Описание"
      alwaysOn
    />,
  ];

  const ListActions = hasCreate => {
    return (
      <TopToolbar>
        {hasCreate && <CreateButton />}
        <ExportXlsButton exporter={SecurityExporter(ROLES)} />
      </TopToolbar>
    );
  };

  return (
    <List
      title="Роли"
      sx={settings.style.expandStyle}
      actions={<ListActions hasCreate={checkPermission(userPermissions, permissions.canCreateRoles)} />}
      filters={filters}
    >
      {isMobile ? (
        <SimpleList
          empty={<EmptyList />}
          linkType={false}
          sx={settings.style.mobileList}
          primaryText={record => (
            <MobileListRow
              fields={[
                { label: "Име", value: record.name },
                { label: "Описание", value: record.description },
              ]}
            />
          )}
          tertiaryText={() =>
            checkPermission(userPermissions, permissions.canUpdateRoles) && <EditButton label="" />
          }
        />
      ) : (
        <Datagrid
          bulkActionButtons={false}
          rowClick={false}
        >
          <TextField
            source="name"
            label="Име"
            sortable={false}
          />
          <TextField
            source="description"
            label="Описание"
            sortable={false}
          />
          {checkPermission(userPermissions, permissions.canUpdateRoles) && <EditButton />}
        </Datagrid>
      )}
    </List>
  );
};
export default ListRoles;
